import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import useCaptcha from 'use-offline-captcha';
import RefreshIcon from '@mui/icons-material/Refresh';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from "react-i18next";
import { Fab, useMediaQuery } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

function Copyright(props) {
    return (
        <Typography variant='body2' color="text.secondary" align='center' {...props}>
            {'Copyright © '}
            < Link color="inherit" href="https://wbsedcl.in/" >
                WEST BENGAL STATE ELECTRICITY DISTRIBUTION COMPANY LIMITED. All Rights Reserved.
            </Link > {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography >
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme({
    components: {
        MuiFormLabel: {
            styleOverrides: {
                asterisk: {
                    color: "#db3131",
                    "&$error": {
                        color: "#db3131",
                    },
                },
            },
        },
    },
});

const consumerIdPattern = /^[0-9]{9}$/;

export default function EntryForm(props) {
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery('(min-width:350px)');

    const [consumerId, setConsumerId] = useState("");
    const [consumerIdErrorMessage, setConsumerIdErrorMessage] = useState("");
    const [consumerIdDisabled, setConsumerIdDisabled] = useState(false);
    const [consumerIdValid, setConsumerIdValid] = useState(false);
    const [consumerIdError, setConsumerIdError] = useState(false);

    const [captchaText, setCaptchaText] = useState("");
    const [captchaTextErrorMessage, setCaptchaTextErrorMessage] = useState("");
    const [captchaTextValid, setCaptchaTextValid] = useState(false);
    const [captchaTextError, setCaptchaTextError] = useState(false);

    const [fromDate, setFromDate] = useState(dayjs());
    const [fromDateErrorMessage, setFromDateErrorMessage] = useState("");
    const [fromDateValid, setFromDateValid] = useState(false);
    const [fromDateError, setFromDateError] = useState(false);

    const [toDate, setToDate] = useState(dayjs());
    const [toDateErrorMessage, setToDateErrorMessage] = useState("");
    const [toDateValid, setToDateValid] = useState(false);
    const [toDateError, setToDateError] = useState(false);

    useEffect(() => {
        if (props && props.prepopulatedConsumerId && props.prepopulatedConsumerId.match(consumerIdPattern)) {
            console.log("cid valid");
            setConsumerIdErrorMessage("");
            setConsumerIdValid(true);
            setConsumerId(props.prepopulatedConsumerId);
            setConsumerIdDisabled(true);
        }
        else {
            setConsumerIdDisabled(false);
            setConsumerIdErrorMessage("");
            setConsumerIdValid(false);
        }

    }, [props.prepopulatedConsumerId])


    const captchaRef = useRef();
    const userOpt = {
        type: 'mixed', // "mixed"(default) | "numeric" | "alpha" 
        length: 5, // 4 to 8 number. default is 5
        sensitive: false, // Case sensitivity. default is false
        width: 170, // Canvas width. default is 200
        height: 44, // Canvas height. default is 50
        fontColor: '#000',
        background: 'rgba(255, 255, 255, .2)'
    }
    const { gen, validate } = useCaptcha(captchaRef, userOpt);

    useEffect(() => {
        if (gen) gen()
    }, [gen])

    const handleRefresh = () => { gen() }

    // useEffect(() => {
    //     if (!consumerId) {
    //         setConsumerIdErrorMessage(
    //             "Please enter consumer Id (অনুগ্রহ করে উপভোক্তা আইডি লিখুন)"
    //         );
    //     }
    //     else if (!consumerId.match(consumerIdPattern)) {
    //         setConsumerIdErrorMessage(
    //             "Please enter valid consumer Id (অনুগ্রহ করে বৈধ উপভোক্তা আইডি লিখুন)"
    //         );
    //     }

    //     if (consumerId.match(consumerIdPattern) && consumerIdErrorMessage) {
    //         setConsumerIdErrorMessage("");
    //         setConsumerIdValid(true);
    //     }
    //     else if (consumerId.length == 0 && consumerIdErrorMessage) {
    //         setConsumerIdErrorMessage("");
    //         setConsumerIdValid(false);
    //     }
    // }, [consumerId]);

    // useEffect(() => {
    //     if (!captchaText) {
    //         setCaptchaTextErrorMessage(
    //             "Please enter captcha text (অনুগ্রহ করে ক্যাপচা টেক্সট লিখুন)"
    //         );
    //     }
    //     else if (captchaText?.trim().length != 5 && !validate(captchaText)) {
    //         setCaptchaTextErrorMessage(
    //             "Please enter valid captcha text (অনুগ্রহ করে বৈধ ক্যাপচা টেক্সট লিখুন)"
    //         );
    //     }

    //     if (captchaText && captchaText?.trim().length == 5 && validate(captchaText) && captchaTextErrorMessage) {
    //         setCaptchaTextErrorMessage("");
    //         setCaptchaTextValid(true);
    //     }
    //     else if (!captchaText && captchaTextErrorMessage) {
    //         setCaptchaTextErrorMessage("");
    //         setCaptchaTextValid(false);
    //     }
    // }, [captchaText]);

    const handleSubmit = (event) => {
        event.preventDefault();
        props.handleTableShow();
        console.log(consumerIdValid, captchaTextValid, fromDateValid, toDateValid);
        if (consumerIdValid && captchaTextValid) {
            props.setLoading();
            const data = new FormData(event.currentTarget);
            const payload = {
                consumerId: consumerId,
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            };
            console.log({
                consumerId: consumerId,
                captcha: data.get('captcha'),
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            });
            props.onVerifySubmit(payload);
        }
        else {
            // props.onVerifySubmit();
            if (!consumerIdValid && !captchaTextValid && !fromDateValid && !toDateValid) {
                setConsumerIdError(true);
                setCaptchaTextError(true);
                // setFromDateError(true);
                // setToDateError(true);
                // setFromDateErrorMessage(t("Please select from date"));
                // setToDateErrorMessage(t("Please select to date"));
                setConsumerIdErrorMessage(
                    t("Please enter Consumer Id")
                );
                setCaptchaTextErrorMessage(
                    t("Please enter captcha text")
                );
            }
            else if (!consumerIdValid) {
                setConsumerIdError(true);
                setConsumerIdErrorMessage(
                    t("Please enter Consumer Id")
                );
            }
            // else if (!fromDateValid) {
            //     setFromDateError(true);
            //     setFromDateErrorMessage(t("Please select from date"));
            // }
            // else if (!toDateValid) {
            //     setToDateError(true);
            //     setToDateErrorMessage(t("Please select to date"));
            // }
            else if (!captchaTextValid) {
                setCaptchaTextError(true);
                setCaptchaTextErrorMessage(
                    t("Please enter captcha text")
                );
            }
            else {
                setConsumerIdError(true);
                setCaptchaTextError(true);
                // setFromDateError(true);
                // setToDateError(true);
                // setFromDateErrorMessage(t("Please select from date"));
                // setToDateErrorMessage(t("Please select to date"));
                setConsumerIdErrorMessage(
                    t("Please enter Consumer Id")
                );
                setCaptchaTextErrorMessage(
                    t("Please enter captcha text")
                );
            }
        }
    };

    const changeLang = () => {
        if (i18n.language == "en") {
            i18n.changeLanguage("bn")
        } else {
            i18n.changeLanguage("en")
        }
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: matches ? 120 : 160,
                    right: 6,
                    display: { xs: 'block', sm: "none", md: 'none', lg: 'none', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 120,
                    right: 6,
                    display: { xs: 'none', sm: "block", md: 'none', lg: 'none', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 112,
                    right: 6,
                    display: { xs: 'none', sm: "none", md: 'block', lg: 'none', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 120,
                    right: 6,
                    display: { xs: 'none', sm: "none", md: 'none', lg: 'block', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 125,
                    right: 6,
                    display: { xs: 'none', sm: "none", md: 'none', lg: 'none', xl: "block" }
                }}>
                    {t("English")}
                </Fab>
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <img src="images/logo.png" className="img-fluid" alt="WBSEDCL" />
                    {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <img src="images/logo.png" height={24} width={24} className="img-fluid" alt="WBSEDCL" />
                    </Avatar> */}
                    <Typography component="h1" variant="h5" textAlign={"center"} sx={{ mt: 2 }}>
                        {t("Register Your Grievance (CGRO/RGRO)")}
                    </Typography>
                    <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <TextField
                                    required
                                    fullWidth
                                    disabled={consumerIdDisabled}
                                    id="consumerId"
                                    label={t("Consumer Id/Application No")}
                                    name="consumerId"
                                    autoComplete="consumerId"
                                    helperText={consumerIdErrorMessage}
                                    value={consumerId}
                                    // onInput={(e)=>{console.log(e);}}
                                    onInput={(e) => {
                                        console.log("cid fired");
                                        setConsumerId(e.target.value);
                                        if ((e.target.value && e.target.value.match(consumerIdPattern))) {
                                            setConsumerIdError(false);
                                        } else {
                                            setConsumerIdError(true);
                                        }

                                        if (!e.target.value) {
                                            setConsumerIdErrorMessage(
                                                t("Please enter Consumer Id")
                                            );
                                        }
                                        else if (!e.target.value.match(consumerIdPattern)) {
                                            setConsumerIdErrorMessage(
                                                t("Please enter valid Consumer Id")
                                            );
                                        }
                                        console.log(consumerIdErrorMessage);
                                        if (e.target.value.match(consumerIdPattern) && consumerIdErrorMessage) {
                                            console.log("cid valid");
                                            setConsumerIdErrorMessage("");
                                            setConsumerIdValid(true);
                                        }
                                        else if (e.target.value.match(consumerIdPattern) && !consumerIdErrorMessage) {
                                            console.log("cid valid");
                                            setConsumerIdErrorMessage("");
                                            setConsumerIdValid(true);
                                        }
                                        else if (e.target.value.length == 0 && consumerIdErrorMessage) {
                                            setConsumerIdErrorMessage("");
                                            setConsumerIdValid(false);
                                        }
                                        else {
                                            setConsumerIdValid(false);
                                        }

                                    }}
                                    error={consumerIdError}
                                />
                            </Grid>
                            {/* <Grid size={12}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                                        <DatePicker
                                            name="fromDate"
                                            format="DD/MM/YYYY"
                                            label={<span>{t("From Date")} <span style={{ color: "#db3131" }}>*</span></span>}
                                            disableFuture
                                            value={fromDate}
                                            onChange={(value) => {
                                                console.log(value);
                                                setFromDate(value);
                                                setToDate(value);
                                                if (value && dayjs(value, true).isValid()) {
                                                    setFromDateError(false);
                                                } else {
                                                    setFromDateError(true);
                                                }

                                                if (!value) {
                                                    setFromDateErrorMessage(
                                                        t("Please select from date")
                                                    );
                                                }
                                                else if (!dayjs(value, true).isValid()) {
                                                    setFromDateErrorMessage(
                                                        t("Please select valid from date")
                                                    );
                                                }

                                                if (dayjs(value, true).isValid() && fromDateErrorMessage) {
                                                    setFromDateErrorMessage("");
                                                    setFromDateValid(true);

                                                    setToDateErrorMessage("");
                                                    setToDateValid(true);
                                                    setToDateError(false);
                                                }
                                                else if (dayjs(value, true).isValid() && !fromDateErrorMessage) {
                                                    setFromDateErrorMessage("");
                                                    setFromDateValid(true);

                                                    setToDateErrorMessage("");
                                                    setToDateValid(true);
                                                    setToDateError(false);
                                                }
                                                else if (!dayjs(value, true).isValid() && fromDateErrorMessage) {
                                                    setFromDateErrorMessage("");
                                                    setFromDateValid(false);
                                                }
                                                else {
                                                    setFromDateValid(false);
                                                }

                                            }}
                                            // minDate={toDate}
                                            slotProps={{
                                                textField: {
                                                    error: fromDateError,
                                                    helperText: fromDateErrorMessage,
                                                },
                                            }} />
                                        <DatePicker
                                            name="toDate"
                                            format="DD/MM/YYYY"
                                            label={<span>{t("To Date")} <span style={{ color: "#db3131" }}>*</span></span>}
                                            defaultValue={dayjs('2023-12-12')}
                                            minDate={fromDate}
                                            disableFuture
                                            slotProps={{
                                                textField: {
                                                    error: toDateError,
                                                    helperText: toDateErrorMessage,
                                                },
                                            }}
                                            value={toDate}
                                            onChange={(value) => {
                                                console.log(value);
                                                setToDate(value);
                                                if (value && dayjs(value, true).isValid()) {
                                                    setToDateError(false);
                                                } else {
                                                    setToDateError(true);
                                                }

                                                if (!value) {
                                                    setToDateErrorMessage(
                                                        t("Please select to date")
                                                    );
                                                }
                                                else if (!dayjs(value, true).isValid()) {
                                                    setToDateErrorMessage(
                                                        t("Please select valid to date")
                                                    );
                                                }

                                                if (dayjs(value, true).isValid() && toDateErrorMessage) {
                                                    setToDateErrorMessage("");
                                                    setToDateValid(true);
                                                }
                                                else if (dayjs(value, true).isValid() && !toDateErrorMessage) {
                                                    setToDateErrorMessage("");
                                                    setToDateValid(true);
                                                }
                                                else if (!dayjs(value, true).isValid() && toDateErrorMessage) {
                                                    setToDateErrorMessage("");
                                                    setToDateValid(false);
                                                }
                                                else {
                                                    setToDateValid(false);
                                                }

                                            }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid> */}
                            <Grid size={12}>
                                <TextField
                                    required
                                    fullWidth
                                    name="captcha"
                                    label={t("Captcha Text")}
                                    type="text"
                                    id="captcha"
                                    autoComplete="false"
                                    // inputProps={{ maxLength: 5 }}
                                    helperText={captchaTextErrorMessage}
                                    value={captchaText}
                                    onInput={(e) => {
                                        setCaptchaText(e.target.value.toUpperCase());
                                        if (e.target.value && e.target.value.length == 5 && validate(e.target.value)) {
                                            setCaptchaTextError(false);
                                        } else {
                                            setCaptchaTextError(true);
                                        }

                                        if (!e.target.value) {
                                            setCaptchaTextErrorMessage(
                                                t("Please enter captcha text")
                                            );
                                        }
                                        else if (e.target.value?.trim().length != 5 && !validate(e.target.value)) {
                                            setCaptchaTextErrorMessage(
                                                t("Please enter valid captcha text")
                                            );
                                        }

                                        if (e.target.value && e.target.value?.trim().length == 5 && validate(e.target.value) && captchaTextErrorMessage) {
                                            setCaptchaTextErrorMessage("");
                                            setCaptchaTextValid(true);
                                        }
                                        else if (e.target.value && e.target.value?.trim().length == 5 && validate(e.target.value) && !captchaTextErrorMessage) {
                                            setCaptchaTextErrorMessage("");
                                            setCaptchaTextValid(true);
                                        }
                                        else if (!e.target.value && captchaTextErrorMessage) {
                                            setCaptchaTextErrorMessage("");
                                            setCaptchaTextValid(false);
                                        }
                                        else {
                                            setCaptchaTextValid(false);
                                        }
                                    }}
                                    error={captchaTextError}
                                />
                                {console.log()}
                            </Grid>
                            <Grid size={{xs: 7, sm: 7}}>
                                <div ref={captchaRef} className="captcha" />
                            </Grid>
                            <Grid size={{xs: 5, sm: 5}} justify="flex-end">
                                <Button variant="contained" onClick={handleRefresh} startIcon={<RefreshIcon fontSize="large" />} sx={{ textTransform: 'capitalize', fontSize: '13px', height: '44px' }} >{t("Refresh")}</Button>
                            </Grid>
                        </Grid>
                        {props.loading ?
                            <LoadingButton
                                fullWidth
                                type="submit"
                                size="large"
                                color="primary"
                                onClick={props.setLoading}
                                loading={props.loading}
                                loadingPosition="start"
                                startIcon={<SendIcon />}
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                <span>{t("Verifying")}...</span>
                            </LoadingButton>
                            :
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                {t("Verify")}
                            </Button>
                        }
                    </Box>
                </Box>
                {/* <Copyright sx={{ mt: 5 }} /> */}
            </Container>
        </ThemeProvider>
    );
}